import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IconButton, useColorModeValue } from '@chakra-ui/react';
import { FaArrowUp } from 'react-icons/fa';

function ScrollToTop() {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const bgColor = useColorModeValue('blue.500', 'blue.200');
  const hoverBgColor = useColorModeValue('blue.600', 'blue.300');
  const color = useColorModeValue('white', 'gray.800');

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      {isVisible && (
        <IconButton
          aria-label="Scroll to top"
          icon={<FaArrowUp />}
          position="fixed"
          bottom="20px"
          right="20px"
          size="lg"
          colorScheme="blue"
          bg={bgColor}
          color={color}
          _hover={{
            bg: hoverBgColor,
            transform: 'translateY(-2px)',
          }}
          _active={{
            transform: 'translateY(0)',
          }}
          onClick={scrollToTop}
          zIndex={999}
          borderRadius="full"
          boxShadow="lg"
          transition="all 0.3s ease"
        />
      )}
    </>
  );
}

export default ScrollToTop; 